@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';
@import '../../../constants/spacing.module.less';

@tag-border-radius: 4px;

.status-label-mixin(@dotColor, @backgroundColor, @borderColor) {
  .status-dot {
    background-color: @dotColor;
  }
  .status-tag-wrapper {
    background-color: @backgroundColor;
    border-color: @borderColor;
  }
}

.status-tag-wrapper {
  display: inline-flex;
  place-content: center center;
  border: 1px solid;
  border-radius: @tag-border-radius;
  height: 24px;
  padding: 0 @space-4;
  gap: @space-4;
}

.status-dot {
  height: 6px;
  width: 6px;
  border-radius: 50%;
  align-self: center;
}

.status-text {
  display: flex;
  align-items: center;
  white-space: nowrap;
  color: var(--gray-0F0F10);
  font-size: 12px;
}

.neutral {
  .status-label-mixin(var(--grey-800), var(--grey-200), var(--grey-300));
}

.success {
  .status-label-mixin(var(--green-10844C), var(--green-EDFDF5), var(--green-B6F6D7));
}

.warning {
  .status-label-mixin(var(--yellow-BD6E00), var(--yellow-FFF6EB), var(--yellow-FFD599));
}

.alert {
  .status-label-mixin(var(--red-700), var(--red-200), var(--red-300));
}

.info {
  .status-label-mixin(var(--blue-1D5AD8), var(--blue-EDF6FF), var(--blue-BFDFFE));
}

.error {
  .status-label-mixin(var(--red-700), var(--red-200), var(--red-300));
}

.readonly {
  .status-label-mixin(var(--grey-800), var(--white), var(--grey-300));
}
